import BASE_URL from './config/env';

export function setupInterceptorForPrizmDoc(
  getDevSession: () => {session: string; token: string}
) {
  const specialHeaderMap = new WeakMap<XMLHttpRequest, boolean>();
  if (window.XMLHttpRequest) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (
      method: string,
      url: string | URL,
      async?: boolean,
      username?: string | null,
      password?: string | null
    ) {
      const absoluteUrl = new URL(url, window.location.origin);
      let finalUrl = absoluteUrl.toString();
      if (typeof finalUrl === 'string') {
        if (finalUrl.includes('/pas') && finalUrl.includes('Art')) {
          specialHeaderMap.set(this, true);
          finalUrl = finalUrl.replace(
            `${window.location.origin}/pas/`,
            `${BASE_URL}/documentmanagement/api/v1/viewer/annotation/`
          );
        } else if (finalUrl.includes('/pas')) {
          specialHeaderMap.set(this, true);
          finalUrl = finalUrl.replace(
            `${window.location.origin}/`,
            `${BASE_URL}/`
          );
        }
      }
      return originalOpen.call(
        this,
        method,
        finalUrl,
        async ?? true,
        username,
        password
      );
    };

    XMLHttpRequest.prototype.send = function (...args) {
      const shouldAddHeader = specialHeaderMap.get(this);
      if (shouldAddHeader) {
        const {session, token} = getDevSession();
        this.setRequestHeader('Authorization', `Bearer ${token}`);
        this.setRequestHeader('X-Dev-Session', session);
      }
      return originalSend.apply(this, args);
    };
  }
}
